// extracted by mini-css-extract-plugin
export default {"main":"Modal_main__IneLD","header":"Modal_header__bMrrX","body":"Modal_body__abGUR"};